import { useState, useCallback, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProductsSection from "./components/ProductsSection";
import DevicesSection from "./components/DevicesSection";
import ReviewsSection from "./components/ReviewsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AnnouncementBar from "./components/AnnouncementBar";
import { useDesignState } from "@/hooks/useDesignSystem";
import { PAGE_BG_PRESETS } from "@/pages/admin/components/design/designConstants";

const HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${import.meta.env.VITE_SITE_URL ?? "https://example.com"}/#website`,
      "url": import.meta.env.VITE_SITE_URL ?? "https://example.com",
      "name": "متجر الإبداع AL Ebdaa",
      "description": "وجهتك الأولى لشراء أجهزة PlayStation 5، PlayStation 4، كمبيوتر ألعاب، أيادي تحكم وإكسسوارات احترافية",
      "inLanguage": "ar-SA",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${import.meta.env.VITE_SITE_URL ?? "https://example.com"}/products?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Store",
      "@id": `${import.meta.env.VITE_SITE_URL ?? "https://example.com"}/#store`,
      "name": "متجر الإبداع AL Ebdaa",
      "url": import.meta.env.VITE_SITE_URL ?? "https://example.com",
      "description": "متجر متخصص في بيع أجهزة الألعاب والإكسسوارات — PS5، PS4، كمبيوتر ألعاب، أيادي تحكم وسماعات",
      "currenciesAccepted": "SAR",
      "paymentAccepted": "Cash, Bank Transfer",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "25 main.st, Al Nuzhah",
        "addressLocality": "Taif",
        "postalCode": "26311",
        "addressCountry": "SA"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 21.2854,
        "longitude": 40.4167
      },
      "hasMap": "https://maps.app.goo.gl/E5Cqt2ggrmYcHYsn9",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.7",
        "reviewCount": "100",
        "bestRating": "5"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Saudi Arabia"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "منتجات الألعاب",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "PlayStation 5" } },
          { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "PlayStation 4" } },
          { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Gaming PC" } },
          { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Controllers" } },
          { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Gaming Headsets" } }
        ]
      }
    }
  ]
};

export default function Home() {
  const [barVisible, setBarVisible] = useState(true);
  const handleBarVisibility = useCallback((v: boolean) => setBarVisible(v), []);
  const { design } = useDesignState();

  const bgPreset = PAGE_BG_PRESETS.find(b => b.id === (design.pageBgId ?? 'black')) ?? PAGE_BG_PRESETS[0];
  const pageBg = design.pageBgId === 'custom'
    ? (design.pageBgCustomColor || '#0a0a0a')
    : bgPreset.color;

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-home";
    script.textContent = JSON.stringify(HOME_SCHEMA);
    document.head.appendChild(script);
    document.title = "متجر الإبداع AL Ebdaa — PS5, PS4, كمبيوتر ألعاب وإكسسوارات";
    return () => {
      const el = document.getElementById("schema-home");
      if (el) el.remove();
    };
  }, []);

  return (
    <div dir="rtl" className="min-h-screen transition-colors duration-500" style={{ background: pageBg }}>
      <AnnouncementBar onVisibilityChange={handleBarVisibility} />
      <Navbar barVisible={barVisible} />
      <main>
        <Hero />
        <ProductsSection />
        <DevicesSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
